import React, { useEffect } from "react";
import Button from "pages/_components/Button";
import GridTable from "pages/_components/GridTable/GridTable";
import I18n from "pages/_components/I18n";
import { useDispatch, useSelector } from "react-redux";
import ProductList from "pages/_components/product/List";
import { bool, string } from "prop-types";
import { actions as transactionLinesActions } from "reducers/form/transactionLines";
import MassiveEcheckColumns from "./massiveEcheckColumns";
import MassiveEcheckRow from "./massiveEcheckRows";

const MassiveEcheckTable = ({ isDesktop, debitAccount, fromTransactionPage, transactionStatus }) => {
    const { transactionLines, transaction, data } = useSelector((state) => state.form);
    const { exchangeToken } = transactionLines;

    const row = isDesktop ? 1 : 3;
    const dispatch = useDispatch();

    const isBackoffice = window.self !== window.top;

    const formatLines = (lines) =>
        lines.map((line) => ({
            lineNumber: line.lineNumber,
            status:
                transactionStatus === "PROCESSING" || transactionStatus === "PENDING" ? transactionStatus : line.status,
            cuitEmit: line.cuitEmit,
            creditCuit: line.creditCuit,
            echeqPayDay: line.echeqPayDay,
            motive: line.motive,
            beneficiaryDocumentNumber: line.beneficiaryDocumentNumber || line.echeqBeneficiaryDocumentNumber,
            beneficiaryName: line.beneficiaryName || line.reference || "--",
            creditAmountQuantity: line.creditAmountQuantity,
        }));

    useEffect(() => {
        if (!isBackoffice) {
            dispatch(transactionLinesActions.clearTransactionLines());
        }
    }, []);

    const lines = formatLines(transactionLines?.list);

    const fetchMoreTransactions = () => {
        dispatch(
            transactionLinesActions.listTransactionLinesRequest({
                id: transaction?.idTransaction,
                pageNumber: transactionLines?.pageNumber + 1,
                status: "TODOS",
                fileId: data?.file[0]?.fileId,
                isBackoffice,
                exchangeToken,
            }),
        );
    };

    return (
        <>
            <h2>
                <I18n id="massiveEcheck.table.title" />
            </h2>

            <ProductList
                fetchingWithPreviousData
                fetching={transactionLines?.fetching}
                items={lines || []}
                noDataText="global.no.results"
                noFiltersDataText="global.no.results"
                renderItem={(item) => (
                    <GridTable.Container
                        key={`list-transaction-item-${item.lineNumber}`}
                        className={`${!isDesktop && "box box-shadow"} full-width`}>
                        <MassiveEcheckRow
                            echeqItem={item}
                            debitAccount={debitAccount}
                            fromTransactionPage={fromTransactionPage}
                            transactionStatus={transactionStatus}
                        />
                    </GridTable.Container>
                )}>
                {(listItem) => (
                    <GridTable className="underlined fromTransactionPage echeck-massive-table tablelist">
                        <GridTable.Header>
                            <GridTable.Container rows={row}>
                                <MassiveEcheckColumns />
                            </GridTable.Container>
                        </GridTable.Header>
                        <GridTable.Body>
                            {listItem}
                            {!transactionLines.lastPage && (
                                <GridTable.Container>
                                    <GridTable.Data columnStart={1} columnWidth={2}>
                                        <Button
                                            onClick={() => fetchMoreTransactions()}
                                            bsStyle="link"
                                            image="images/figma/icon/arrow.svg"
                                            label="global.showMore"
                                        />
                                    </GridTable.Data>
                                </GridTable.Container>
                            )}
                        </GridTable.Body>
                    </GridTable>
                )}
            </ProductList>
        </>
    );
};

MassiveEcheckTable.propTypes = {
    isDesktop: bool.isRequired,
    debitAccount: string.isRequired,
    fromTransactionPage: bool,
    transactionStatus: string,
};

MassiveEcheckTable.defaultProps = {
    fromTransactionPage: false,
    transactionStatus: "",
};

export default MassiveEcheckTable;
